export default "__VITE_ASSET__Pbpbrbxs__"